import React, { Component } from 'react';

import { History as history, Routes as routes } from '../navigation';
import { Header } from '../components';
import '../css/SignIn.css';

class ProviderWelcomeMessage extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderProviderWelcomeMessage = () => {
    const alerts  = this.props.alerts || [];
    const practice_id = this.props.selectedPractice || '';
    const user_id = this.props.userId || '';
    const alert   = this.getAlertForPractice(practice_id, user_id, alerts);
    const exists  = alert ? true : false;

    return <div className="standard-container">
      <Header title='Welcome Message'
              icon='fas fa-user-edit'
              button_title={ exists ? 'Edit Message' : 'Add Message' }
              button_action={ () => {
                const screenProps = {
                  alertType: 'welcome',
                  practice_id: practice_id,
                  user_id: user_id,
                  alert: alert,
                }
                history.push({ pathname: routes.PRACTICE_ALERT_EDIT, state: { props: screenProps } })
              }}/>
      <div style={{ padding: 15 }}>
        <span style={{ color: 'grey', fontSize: 14 }}>Add a message that appears on Clients' screens as soon as they fill out the consultation form and start a consultation.</span>
      </div>
    </div>
  }

  render() {
    return this.renderProviderWelcomeMessage();
  }

  getAlertForPractice = (practice_id, user_id, alerts) => {
    var welcomeMessage = null;
    alerts.forEach((alert) => {
      if (alert.practice_id === practice_id && alert.type === 'WELCOME' && alert.provider_id === user_id) {
        welcomeMessage = alert;
      }
    })
    return welcomeMessage;
  }

}


export default ProviderWelcomeMessage
